import axios, { AxiosError } from 'axios'

/** Helper for axios error guard. Default `isAxiosError` crashes when error is `undefined`. */
export function isAxiosError(error: unknown): error is AxiosError {
	if (error === undefined || error === null) return false
	return axios.isAxiosError(error)
}

type ErrorWithMessage = {
	message: string
}

function isErrorWithMessage(error: unknown): error is ErrorWithMessage {
	return (
		typeof error === 'object' &&
		error !== null &&
		'message' in error &&
		typeof (error as Record<string, unknown>).message === 'string'
	)
}

function toErrorWithMessage(maybeError: unknown): ErrorWithMessage {
	if (isErrorWithMessage(maybeError)) return maybeError

	try {
		return new Error(JSON.stringify(maybeError))
	} catch {
		// fallback in case there's an error stringifying the maybeError
		// like with circular references for example.
		return new Error(String(maybeError))
	}
}

export function getErrorMessage(error: unknown) {
	return toErrorWithMessage(error).message
}

/**
 * Use this when you need to go home and refresh everything.
 * This will do a full refresh and opt out of SPA.
 * Ideally you would use navigation library along with proper cache invalidation.
 */
export function forceNavigateHome() {
	window.location.href = '/'
}
